import React, { createContext, useState, useEffect } from 'react';

// Create a context for the user
export const userContext = createContext();

const ContextProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);

  // Check for token in localStorage on initial render
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setAuthenticated(true);
    }
  }, []);
  // Function to log in the user
  const login = (token) => {
    localStorage.setItem('token', token);
    setAuthenticated(true);
  };

  // Function to log out the user
  const logout = () => {
    localStorage.clear();
    setAuthenticated(false);
  };

  return (
    <userContext.Provider value={{ authenticated, login, logout }}>
      {children}
    </userContext.Provider>
  );
};

// Function to decode the JWT token (add your own decoding logic)
const decodeToken = (token) => {
  try {
    const payload = token.split('.')[1]; // Get the payload part of the JWT
    const decodedPayload = JSON.parse(atob(payload)); // Decode from base64

    return decodedPayload.role; // Assuming role is stored in the token payload
  } catch (error) {
    console.error('Error decoding token:', error);
    return null; // Return null if there's an error
  }
};

export default ContextProvider;